export const VocabAboutContent = {
    'companny_section_id': ['company', 'company'],
    'companny_section_title': ['Nosotros', 'Company'],
    
    
    'background_id': ['background', 'background'],
    'background_title': ['Antecedentes', 'Background'],
    'background_body': [
        'Durante la pandemia de COVID-19 frente al rápido deterioro de la psique y salud social, aunado a una plétora de información falsa o errónea. Empecé a conceptualizar una plataforma con un repositorio confiable que propicie un análisis meticuloso; desencadenando diagnósticos precisos, robustecidos por un seguimiento activo con los pacientes, incentivando el cumplimiento de los tratamientos y podernos enfocar en la  prevención. Dicha herramienta facilitaría el trabajo de aquellos en la primera línea, esos valientes que velan por nuestra salud.\n\nAl ser una suite que compila información tiene como propósito procesar la inmensa cantidad de datos en información concreta y discernible para mejorar la  toma de decisiones; en este tiempo de gran adversidad y unidad, por una amenaza microscópica nace la pregunta Si hay apps sociales ¿porque no de salud?.\n\nDurante el desarrollo del concepto noté la parcialidad en la atención y un sesgo en la salud de la mujer; por eso y más nace MedCleir. Adoptando la parte de la raíz de la palabra medicina y dos nombres Clío musa de la historia e hija de Zeus y Eir una valkiria mítica con gran destreza en la curación y estrecha relación con la salud; un nombre homólogo de  remembranza, paz, piedad y protección, haciendo honor a la dualidad femenina a su eterna delicadeza y admirable fortitud, dualidad misma que a todos define, el balance que conocemos como vida.', 
        'Addresses'
    ],

    'vision_id': ['vision', 'vision'],
    'vision_title': ['Visión', 'Addresses'],
    'vision_body': [
        'Trabajamos para ser pioneros en implementaciones tecnológicas, mediante la mejora continua y propuestas novedosas, simples, y de alto impacto llegaremos a convertirnos en la empresa líder y un referente mundial en gestión y presentación de información de la salud', 
        'Addresses'
    ],

    'mission_id': ['mision', 'mision'],
    'mission_title': ['Misión', 'Address'],
    'mission_body': [
        'Somos una organización simple, innovadora, competitiva, comprometida con el bienestar y gestión de la información de nuestros asociados, brindando un servicio amigable a través de soluciones extraordinarias.', 
        'Address'
    ],

    'contact_id': ['Envianos un mensaje', 'Send us a message'],
    'contact_title': ['Contactanos', 'Contact us'],
    'contact_body': [
        "Envíanos un mensaje, te responderemos tan pronto nos sea posible.", 
        "Send us a message, we'll get back to you as soon as possible."
    ],

    'name_origin_id': ['name_origin_id', 'name_origin_id'],
    'name_origin_title': ['Nuestro nombre', 'Our name'],
    'name_origin_body': [
        'El nombre MedCleir nace de tres conceptos:\n Comenzamos con Med, Comenzamos con Med, conjunto de tres letras que escuchamos con frecuencia en palabras como médico, medicina o remedio todas tienen encuentran su raíz en el verbo latino "medeor, medērī que significa cuidar, atender, curar, el sustantivo  medicus → el que cuida, el que trata y medicina → el arte de curar. Naturalmente orbitamos hacia este concepto porque buscamos ayudar en esta vieja arte.\n\n Seguimos con la diosa Clio (Κλειώ) una de nueve hijas de Zeus y Mnemósine, ella es la musa de la historia y retórica; así pues adoptamos parte de su nombre ya que refleja parte de nuestra propia esencia siendo nuestro objetivo salvaguardar tu información y comunicarla cuál historiador.\n\nFinalmente Eir diosa nórdica asociada con la salud y euforia, su nombre significa paz, clemencia y piedad ella es una valquiria de gran destreza en sanación; con ella referimos a la dualidad femenina a su eterna delicadeza y admirable fortitud, dualidad misma que a todos define, ante nuestros ojos el balance mismo  que conocemos como vida.', 
        'Address'
    ],

    'philosophy_section_id': ['philosophy', 'philosophy'],
    'philosophy_section_title': ['Filosofía', 'Philosophy'],

    'mexico_id': ['mexico', 'Philosophy'],
    'mexico_title': ['México', 'Philosophy'],
    'mexico_body': [
        'Preservamos el historial médico bajo estricto apego a la normativa oficial y mejores prácticas.\nNos comprometemos a la generación de conocimiento con la información que la sociedad nos fíe, mediante modelos epidemiológicos y estadísticos intentaremos trabajar con organismos clave de salud pública en pro de la salud.', 
        'Philosophy'
    ],

    'patients_id': ['patients', 'patients'],
    'patients_title': ['Pacientes', 'Philosophy'],
    'patients_body': [
        'Facilitamos la gestión y comprensión de su información, fungimos como guía para llevarlos a una mejor calidad de vida, vitoreandolos en cada paso.', 
        'Philosophy'
    ],

    'professionals_id': ['professionals', 'professionals'],
    'professionals_title': [
        'Profesionales de la salud', 'Philosophy'],
    'professionals_body': [
        'Facilitamos la captura, acceso y seguimiento de información crítica para de sus pacientes, proporcionando todo lo necesario de manera clara, eficiente, estética y oportuna; favoreciendo un mejor diagnóstico y toma de decisiones respetando siempre su criterio, además les allanamos el camino a mejores prácticas y estrechamos los canales de comunicación entre pacientes, médicos y farmacéuticas.', 
        'Philosophy'
    ],

    'pharmaceutical_id': ['pharmaceutical', 'pharmaceutical'],
    'pharmaceutical_title': [
        'Sector farmacéutico', 'Philosophy'],
    'pharmaceutical_body': [
        'Facilitamos información útil para el desarrollo y mejora de los productos farmacéuticos. Ofrecemos una plataforma para interactuar de manera más cercana con los profesionales de la salud y sus pacientes.', 
        'Philosophy'
    ],

    'our_team_id': ['our_team', 'our_team'],
    'our_team_title': ['Nuestro equipo', 'Out team'],
    'our_team_body': [
        'Consideramos su habilidad, ingenio, esfuerzo y compromiso la piedra angular de nuestro futuro, por ello nuestra relación se basa en un fuerte compromiso de respetar un equilibrio entre su vida profesional y personal, con interés de evolucionar sinérgicamente por ello contribuimos a su crecimiento y desarrollo.', 
        'Philosophy'
    ],


    'jobs_section_id': ['jobs', 'jobs'],
    'jobs_section_title': ['Empleos', 'Jobs'],


    'contact_section_id': ['contact', 'contact'],
    'contact_section_title': ['Contacto', 'Contact'],
  }
    